import { Stack } from '@mui/material';
import { ButtonLink } from 'component-library';
import { Text } from 'deprecated-component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { OnboardingPageHeading, OnboardingPagePaper } from '@/layout/OnboardingPage';
import { paths } from '@/routing';

export const ResetPasswordSubmitted: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <OnboardingPageHeading headlineText={t('passwordReset.success.title')} />
      <OnboardingPagePaper>
        <Stack spacing={3}>
          <Text variant='body1'>{t('passwordReset.success.subtitle')}</Text>
          <ButtonLink to={paths.login} size='medium' className='self-end'>
            {t('passwordReset.success.backButton')}
          </ButtonLink>
        </Stack>
      </OnboardingPagePaper>
    </>
  );
};
